<template>
  <div class="bg-secondary footer">

    <div class="spacer"></div>
    <div class="copyright">© 2024 Benjamin da Silva Moreira</div>
    <div class="spacer"></div>

  </div>
</template>

<script>


export default {
  name: "Footer",
  data() {
    return {      
    };
  },
  methods: {
  },
};
</script>

<style scoped>
span {
  font-weight: 500;
}

.footer {
  display: flex !important;
  align-items: center !important; 
  align-content: center !important; 
  height: 50px;
  flex-wrap: wrap;  
}

.copyright {   
  color: white;
  font-weight: 500;
  width: 80%;
  text-align: center;
}

.spacer {
  width: 10%
}

</style>
